"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MetricCategory {
    constructor(boxplot, id, codes) {
        this.codes = [];
        this.metrics = [];
        this.boxplot = boxplot;
        this.id = id;
        this.codes = codes;
    }
    init(metrics, dimension) {
        if (dimension === 'bio') {
            metrics = metrics.map((m) => m);
            if (this.codes.length) {
                metrics = metrics.filter((metric) => {
                    const categoryMatch = this.codes.includes(metric.typeCode);
                    if (categoryMatch) {
                        return true;
                    }
                    const codesCatAndMetric = this.codes
                        .filter((c) => c.includes('@'))
                        .map((c) => c.split('@'))
                        .map((c) => ({ category: c[0], metric: c[1] }));
                    for (const catAndMetric of codesCatAndMetric) {
                        if (metric.typeCode === catAndMetric.category &&
                            metric.code === catAndMetric.metric) {
                            return true;
                        }
                    }
                    return false;
                });
            }
            metrics.sort((a, b) => b.becropScoreChange - a.becropScoreChange);
        }
        this.metrics = metrics;
    }
}
exports.default = MetricCategory;
